/**
 * Returns the result of setting the first letter of the provieded `input` parameter to Uppercase.
 */
const uppercaseFirstLetter = (input: string) => `${input.charAt(0).toUpperCase()}${input.slice(1)}`;

/**
 * Returns a representation of `input` in which the first letter and each letter after a space are upper case.
 * All other letters are lowercase. Digits and special characters are unaffected.
 */
export const capitalize = (input: string): string => (
  (input || '')
    .toLowerCase()
    .split(' ')
    .map(uppercaseFirstLetter)
    .join(' ')
);
